import Base from './Base.js';

class Account extends Base {
    createAccount(payload, params) {
        return this.apiClient.post('account/organization/', payload, params, true);
    }

    contactUs(payload, params) {
        return this.apiClient.post('account/contactUs/', payload, params);
    }

    subscribe(payload, params) {
        return this.apiClient.post('account/newsGuestSubscription/', payload, params, true);
    }
}

export default Account;
